// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { Route, Switch, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import FlightsCurrentContainer from '../containers/FlightsCurrentContainer';
import FlightsPastContainer from '../containers/FlightsPastContainer';
import Banner from '../../../elements/Banner/Banner';
import routes from '../../../routes';
import Page from '../../../Page';

import subNavStyle from '../../../assets/styles/sub-nav.scss';
import icons from '../../../assets/styles/icons.scss';
import style from './Flights.scss';

import type { Location } from '../../../router';

type Props = {
  +location: Location;
};

export default class Flights extends Component<Props, void> {
  render() {
    const { location } = this.props;
    const subRoute = location.pathname.split('/')[2];
    return (
      <section className={style.mainFlightsWrap}>
        <Banner translatedId="flights.header.title"
                color="orange"
                rightElement={<Link to="/new-flight">
                  <i className={icons.iconAirplaneAddMedium}/>
                  <FormattedMessage id="flights.nav.newFlight"/>
                </Link>}/>
        <nav className={classNames(subNavStyle.subNav, subNavStyle.orange)}>
          <section>
            <ul>
              <li className={classNames({ [subNavStyle.active]: subRoute === 'current' })}>
                <FormattedMessage id="flights.nav.current">{
                  txt => (<Link to="/flights/current">{txt}</Link>)
                }</FormattedMessage>
              </li>
              <li className={classNames({ [subNavStyle.active]: subRoute === 'past' })}>
                <FormattedMessage id="flights.nav.past">{
                  txt => (<Link to="/flights/past">{txt}</Link>)
                }</FormattedMessage>
              </li>
            </ul>
          </section>
        </nav>
        <Switch>
          <Redirect from={routes.FLIGHTS.routePath} exact to={routes.FLIGHTS.children.CURRENT.routePath}/>
          <Route path={routes.FLIGHTS.children.CURRENT.routePath}
                 render={props => <Page name={routes.FLIGHTS.children.CURRENT.name}>
                   <FlightsCurrentContainer {...props}/>
                 </Page>}/>
          <Route path={routes.FLIGHTS.children.PAST.routePath}
                 render={props => <Page name={routes.FLIGHTS.children.PAST.name}>
                   <FlightsPastContainer {...props}/>
                 </Page>}/>
        </Switch>
      </section>
    );
  }
}

Flights.propTypes = {
  location: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/flights/components/Flights.jsx